import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Loading from '@components/Loading';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import InquiryComments from './components/InquiryComments';
import InquiryContent from './components/InquiryContent';
import InquiryFooter from './components/InquiryFooter';
import InquiryHeader from './components/InquiryHeader';
import InquiryNavigator from './components/InquiryNavigator';
import useInquiry from './hooks/useInquiry';

interface Params {
    inquiryId: string;
}

declare module '@stackflow/config' {
    interface Register {
        InquiryLogActivity: Params;
    }
}

const InquiryLogActivity: ActivityComponentType<'InquiryLogActivity'> = ({ params }) => {
    const { t } = useTranslation('inquiry');
    const { inquiryId } = params;
    const { inquiry, isFetching } = useInquiry(inquiryId);
    return (
        <AppScreen>
            <CtaLayout header={<Header title={t('header.title')} />}
                footer={inquiry ? <InquiryFooter inquiry={inquiry}/> : undefined} >
                {inquiry && (
                    <Container>
                        <InquiryHeader inquiry={inquiry}/>
                        <InquiryContent inquiry={inquiry}/>
                        <InquiryComments inquiry={inquiry}/>
                        <InquiryNavigator/>
                    </Container>
                )}
                {isFetching && (<Loading/>)}
            </CtaLayout>
        </AppScreen>
    );
};

const Container = styled.div`
    width: 100%;
    min-height: 100%;
    position: relative;
`;

export default InquiryLogActivity;
